import { CALL_API } from '../middleware/api';

export const LOADING_AGREEMENT_CATEGORIES_LIST = Symbol('LOADING_AGREEMENT_CATEGORIES_LIST');
export const LOADED_AGREEMENT_CATEGORIES_LIST = Symbol('LOADED_AGREEMENT_CATEGORIES_LIST');
export const LOADING_MANAGEMENT_AGREEMENT_CATEGORIES_LIST = Symbol('LOADING_MANAGEMENT_AGREEMENT_CATEGORIES_LIST');
export const LOADED_MANAGEMENT_AGREEMENT_CATEGORIES_LIST = Symbol('LOADED_MANAGEMENT_AGREEMENT_CATEGORIES_LIST');
export const AGREEMENT_CATEGORIES_SORT = Symbol('AGREEMENT_CATEGORIES_SORT');
export const DELETE_MANAGEMENT_AGREEMENT_CATEGORY_SUCCESS = Symbol('DELETE_MANAGEMENT_AGREEMENT_CATEGORY_SUCCESS');

export function getAgreementCategories() {
  return {
    [CALL_API]: {
      method: 'get',
      path: '/api/v1/browse/agreement_categories',
      startType: LOADING_AGREEMENT_CATEGORIES_LIST,
      successType: LOADED_AGREEMENT_CATEGORIES_LIST,
    },
  };
}

export function getManagementAgreementCategories() {
  return {
    [CALL_API]: {
      method: 'get',
      path: '/api/v1/browse/agreement_categories',
      startType: LOADING_MANAGEMENT_AGREEMENT_CATEGORIES_LIST,
      successType: LOADED_MANAGEMENT_AGREEMENT_CATEGORIES_LIST,
    },
  };
}

export const sortAgreementCategories = field => ({ type: AGREEMENT_CATEGORIES_SORT, field });

export const saveAgreementCategory = ({ id, category, isLinkable, parentId, afterSuccess, afterError }) => {
  const api = {
    method: 'post',
    path: '/api/v1/agreement_categories',
    body: { category, isLinkable, parentId },
    skipGlobalErrorHandler: true,
    afterSuccess,
    afterError,
  };

  if (id) {
    api.method = 'put';
    api.path = `/api/v1/agreement_categories/${id}`;
  }

  return { [CALL_API]: api };
};

export const deleteAgreementCategory = ({ id, afterSuccess, afterError }) => ({
  id,
  [CALL_API]: {
    method: 'delete',
    path: `/api/v1/agreement_categories/${id}`,
    successType: DELETE_MANAGEMENT_AGREEMENT_CATEGORY_SUCCESS,
    afterSuccess,
    afterError,
  },
});
